import { useInfiniteQuery } from "@tanstack/react-query";
import { convertLogs, LogFilter } from "../types/log";
import { STALE_TIME } from "../types/staleTime";
import { apiGet } from "./query";

const ENDPOINT = "log"
const PAGE_LIMIT = 100;

export const useLogGetAll = (filter?: LogFilter) => {
  const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage, error, refetch, isFetching } = useInfiniteQuery({
    queryKey: ["log", JSON.stringify(filter)],
    queryFn: async ({ pageParam = 0 }) => {
      const queryParams = new URLSearchParams({
        page: pageParam.toString(),
        limit: PAGE_LIMIT.toString(),
      })

      if (filter?.scanner) queryParams.append("scanner_id", String(filter.scanner))

      const url = `${ENDPOINT}/filtered?${queryParams.toString()}`;

      return (await apiGet(url, convertLogs)).data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length < PAGE_LIMIT ? undefined : allPages.length;
    },
    staleTime: STALE_TIME.MIN_5,
    throwOnError: true,
  })

  const logs = data?.pages.flat() ?? [];

  return {
    data: logs,
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    error,
    refetch,
    isFetching,
  }
}
